import { getTimeString, numberWithCommas } from '../common/util';
import { SoundManager } from '../common/audio/soundManager';
import { UIGrid } from '../common/ui/uiGrid';
import { UIImage } from '../common/ui/uiImage';
import { UIPanel } from '../common/ui/uiPanel';
import { UIPanelButton } from '../common/ui/uiPanelButton';
import { UIScreen } from '../common/ui/uiScreen';
import { UIText } from '../common/ui/uiText';
// import { Site } from 'src/site/site';
import { Game, GameMode } from './game';
import { GameStyle } from './gameStyle';
import { PowerUpType } from './matchThree';
import { MatchThreePanel } from './matchThreePanel';
import { PowerupImage } from './pupListDialog';
import { UICanvas } from '../common/ui/uiCanvas';
import { Server } from '../../server/server';
import { AppConfig } from '../../app/AppConfig';

export class GameScreen extends UIScreen {
  protected playWithFriendsButton: UIPanelButton;
  protected menuPanel: UIPanel;
  protected toggleSoundOnIcon: UIImage;
  protected toggleSoundOffIcon: UIImage;
  protected scoreText: UIText;
  protected timeLabel: UIText;
  protected timeText: UIText;
  protected smallGemLockedImage: string;
  protected smallGemImages: string[];
  protected numGoals: any;
  protected goalImages: UIImage[];
  protected goalAmountTexts: UIText[];
  protected goalsPanel: UIPanel;
  protected goalsGrid: UIGrid;
  public powerupsPanel: UIPanel;
  protected gamePanel: MatchThreePanel;
  protected powerUpButtons: UIPanelButton[];
  protected powerUpImages: UIImage[];
  protected powerUpAmountText: UIText[];
  protected timeFreezeImage: UIImage;
  protected timeFreezeShadowText: UIText;
  protected timeFreezeText: UIText;
  levelText: UIText;
  levelPanel: UIPanel;

  protected readyGoText: UIText;
  protected playPlaceButton: UIPanelButton;

  public build() {
    let background = new UIPanel({
      color : GameStyle.backgroundColors.game.outer,
      fitParent : {left : 0, top : 0, right : 0, bottom : 0},
      parent : this
    });

    let innerPanel = new UIPanel({
      color : GameStyle.backgroundColors.game.inner,
      fitParent : {left : 0, top : 60, right : 0, bottom : 70},
      // radius: 30,
      parent : this
    });

    this.gamePanel = new MatchThreePanel({
      fitParent : {left : 10, top : 120, right : 10, bottom : 100},
      parent : this
    });

    this.buildTopBar();
    this.buildMenu();
    // this.buildBottomBar();

    this.powerupsPanel = new UIPanel({
      size : {x : 190, y : 70},
      position : {x : 0, y : 0},
      anchor: {x: 0, y: 1},
      pivot: {x: 0, y: 1},
      parent : this
    });

    this.goalsPanel = new UIPanel({
      fitParent: {left: 0, right: 0, top: -1, bottom: -1},
      size : {x : 200, y : 50},
      position : {x : 0, y : 60},
      color: '#00000020',
      parent : this
    });

    this.goalsGrid = new UIGrid({
      columns : 4,
      rows : 1,
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      spacing : {x : 5, y : 0},
      fitParent : {left : -1, right : -1, top : 0, bottom : 0},
      // color: '#ffffff',
      parent : this.goalsPanel
    });

    this.readyGoText = new UIText({
      text : '',
      fontFamily : 'verdana',
      fontSize : 40,
      fontWeight: '800',
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      position: {x: 0, y: 180},
      strokeLineWidth: 5,
      strokeColor: '#000000',
      color: '#FFF200',
      parent : this
    })
  }

  protected buildTopBar() {
    let topbar = new UIPanel({
      fitParent: {left: 0, right: 0, top: -1, bottom: -1},
      size: {x: 0, y: 60},
      parent : this
    });

    this.levelPanel = new UIPanel({
      position : {x : -60, y : 10},
      anchor : {x : 1, y : 0},
      pivot : {x : 1, y : 0},
      size: {x: 80, y: 40},
      radius: GameStyle.header.panel.radius,
      color: GameStyle.header.panel.color,
      parent : topbar
    });

    let leveLabel = new UIText({
      text : 'LEVEL',
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      position: {x: 0, y: 1},
      fontFamily: GameStyle.header.label.fontFamily,
      fontSize: GameStyle.header.label.fontSize,
      color: GameStyle.header.label.color,
      parent : this.levelPanel
    });

    this.levelText = new UIText({
      text : '0',
      anchor: {x: 0.5, y: 0.5},
      pivot: {x: 0.5, y: 0.5},
      position: {x: 0, y: 7},
      fontFamily: GameStyle.header.value.fontFamily,
      fontSize: GameStyle.header.value.fontSize,
      color: GameStyle.header.value.color,
      parent : this.levelPanel
    });

    let scorePanel = new UIPanel({
      anchor: {x: 0.5, y: 0.5},
      pivot: {x: 0.5, y: 0.5},
      size: {x: 80, y: 40},
      radius: GameStyle.header.panel.radius,
      color: GameStyle.header.panel.color,
      parent : topbar
    });

    let scoreLabel = new UIText({
      text : 'SCORE',
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      position: {x: 0, y: 1},
      fontFamily: GameStyle.header.label.fontFamily,
      fontSize: GameStyle.header.label.fontSize,
      color: GameStyle.header.label.color,
      parent : scorePanel
    });

    this.scoreText = new UIText({
      text : '0',
      anchor: {x: 0.5, y: 0.5},
      pivot: {x: 0.5, y: 0.5},
      position: {x: 0, y: 7},
      fontFamily: GameStyle.header.value.fontFamily,
      fontSize: GameStyle.header.value.fontSize,
      color: GameStyle.header.value.color,
      parent : scorePanel
    });

    let timePanel = new UIPanel({
      anchor: {x: 0, y: 0.5},
      pivot: {x: 0, y: 0.5},
      position: {x: 60, y: 0},
      size : {x : 80, y : 40},
      radius: GameStyle.header.panel.radius,
      color: GameStyle.header.panel.color,
      parent : topbar
    });

    this.timeLabel = new UIText({
      text : 'TIME',
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      position: {x: 0, y: 1},
      fontFamily: GameStyle.header.label.fontFamily,
      fontSize: GameStyle.header.label.fontSize,
      color: GameStyle.header.label.color,
      parent : timePanel
    });

    this.timeText = new UIText({
      text : '0:00',
      anchor: {x: 0.5, y: 0.5},
      pivot: {x: 0.5, y: 0.5},
      position: {x: 0, y: 7},
      fontFamily: GameStyle.header.value.fontFamily,
      fontSize: GameStyle.header.value.fontSize,
      color: GameStyle.header.value.color,
      parent : timePanel
    });

    this.timeFreezeImage = new UIImage({
      url : require('./assets/powerUpTimeFreeze.png'),
      anchor: {x: 0, y: 0.5},
      pivot: {x: 0, y: 0.5},
      position : {x : 3, y : 5},
      size : {x : 23, y : 23},
      stretch : true,
      visible : true,
      parent : timePanel
    });

    // this.timeFreezeText = new UIText({
    //   text : '10',
    //   color : '#ffffff',
    //   fontFamily : 'impact',
    //   fontSize : 20,
    //   anchor : {x : 0, y : 0},
    //   pivot : {x : 0, y : 0},
    //   position : {x : 22, y : 22},
    //   parent : this.timeFreezeImage
    // });

    this.playPlaceButton = new UIPanelButton({
      size: {x: 40, y: 40},
      position: {x: 10, y: 10},
      callback : (btn:UIPanelButton) => {
        this.onPPMenu();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      borderWidth: GameStyle.dialog.button.borderWidth,
      borderColor: GameStyle.dialog.button.borderColor,
      parent : topbar
    });

    let playPlaceIcon = new UIImage({
      url : '/playplace.png',
      parent : this.playPlaceButton
    });

    let pauseButton = new UIPanelButton({
      anchor: {x: 1, y: 0},
      pivot: {x: 1, y: 0},
      size: {x: 40, y: 40},
      position: {x: -10, y: 10},
      callback : (btn:UIPanelButton) => {
        this.onPause();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      borderWidth: GameStyle.dialog.button.borderWidth,
      borderColor: GameStyle.dialog.button.borderColor,
      parent : topbar
    });

    let pauseIcon = new UIImage({
      url : require('./assets/menu.png'),
      parent : pauseButton
    });
  }

  protected buildBottomBar() {
    let bottombar = new UIPanel({
      fitParent: {left: 0, right: 0, top: -1, bottom: -1},
      size: {x: 0, y: 60},
      anchor: {x: 0, y: 1},
      pivot: {x: 0, y: 1},
      parent : this
    });

    // let leaderboard = new LeaderboardPanel({
    //   fitParent: {left: 10, right: 110, top: 10, bottom: 10},
    //   callback: ()=>{
    //     this.onLeaderboardClick();
    //   },
    //   lifetimeScoreCookieId: 'MatchThreeLifetimeScore',
    //   fontFamily: GameStyle.leaderboard.fontFamily,
    //   fontSize: GameStyle.leaderboard.fontSize,
    //   nameColor: GameStyle.leaderboard.nameColor,
    //   localNameColor: GameStyle.leaderboard.localNameColor,
    //   scoreColor: GameStyle.leaderboard.scoreColor,
    //   panelColor: GameStyle.leaderboard.panelColor,
    //   panelRadius: GameStyle.leaderboard.panelRadius,
    //   parent : bottombar
    // });

    // this.playWithFriendsButton = new UIPanelButton({
    //   text: 'Play With\nFriends',
    //   anchor: {x: 0.5, y: 0.5},
    //   pivot: {x: 0.5, y: 0.5},
    //   size: {x: 90, y: 40},
    //   position: {x: 0, y: 0},
    //   callback : (btn:UIPanelButton) => {
    //     // this.onPlayWithFriends();
    //   },
    //   panelColors : GameStyle.playWithFriends.panelColors,
    //   borderColor: GameStyle.playWithFriends.borderColor,
    //   borderWidth: GameStyle.playWithFriends.borderWidth,
    //   textOffset: GameStyle.playWithFriends.textOffset,
    //   fontFamily: GameStyle.playWithFriends.fontFamily,
    //   fontSize: GameStyle.playWithFriends.fontSize,
    //   radius: GameStyle.playWithFriends.radius,
    //   parent : bottombar
    // });
  }

  protected buildMenu() {
    this.menuPanel = new UIPanel({
      size: {x: 40, y: 140},
      position: {x: 10, y: 60},
      parent : this
    });

    let toggleSoundButton = new UIPanelButton({
      size : {x : 40, y : 40},
      position : {x : 0, y : 0},
      callback : () => {
        this.menuPanel.visible = false;
        // Game.game.solitaire.toggleSfxOn();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      borderWidth: GameStyle.dialog.button.borderWidth,
      borderColor: GameStyle.dialog.button.borderColor,
      parent : this.menuPanel
    });

    this.toggleSoundOnIcon = new UIImage({
      url : require('./assets/togglesoundon.png'),
      parent : toggleSoundButton
    });

    this.toggleSoundOffIcon = new UIImage({
      url : require('./assets/togglesoundoff.png'),
      parent : toggleSoundButton
    });
  }

  protected buildGoals() {
    this.goalsGrid.deleteAllChildren();

    let goals = Game.instance.matchThree.getGoals();
    if(!goals)
      return;

    this.goalsGrid.columns = goals.length;
    if(Game.instance.matchThree.getGoalsLocked() > 0)
      this.goalsGrid.columns++;

    this.goalsGrid.size.x = this.goalsGrid.columns * 90;

    let smallGemLockedImage = require('./assets/goalGemLocked.png');

    let smallGemImages = [
      require('./assets/goalGem0.png'), require('./assets/goalGem1.png'),
      require('./assets/goalGem2.png'), require('./assets/goalGem3.png'),
      require('./assets/goalGem4.png'), require('./assets/goalGem5.png')
    ];

    for(let i = 0; i < this.goalsGrid.columns; i++) {
      let panel = new UIPanel({
        // color: '#00000020',
        parent : this.goalsGrid
      });

      let goalImage = new UIImage({
        url : (i < goals.length) ? smallGemImages[goals[i].gemType] : smallGemLockedImage,
        anchor: {x: 0.5, y: 0.5},
        pivot: {x: 1, y: 0.5},
        position : {x : -5, y : 0},
        size : {x : 30, y : 30},
        stretch : true,
        parent : panel
      });

      let goalAmountText = new UIText({
        text : '0',
        anchor: {x: 0.5, y: 0.5},
        pivot: {x: 0, y: 0.5},
        position : {x : 5, y : 0},
        fontFamily: GameStyle.header.value.fontFamily,
        fontSize: GameStyle.header.value.fontSize,
        color: GameStyle.header.value.color,
        parent : panel
      });
    }
  }

  public buildPowerups() {
    let slot_1 = localStorage.getItem('slot-1');
    let slot_2 = localStorage.getItem('slot-2');
    let slot_3 = localStorage.getItem('slot-3');

    this.buildSlot(slot_1, 10);
    this.buildSlot(slot_2, 70);
    this.buildSlot(slot_3, 130);
  }

  protected buildSlot(selection: any, x: number) {
    let slot_props   = this.setSlotProps(selection, x);
    let slot         = new UIPanelButton(slot_props);

    if (selection) {
      let url        = PowerupImage.get(Number(selection));
      let img_props  = this.setSlotImageProps(url, slot);
      let slot_image = new UIImage(img_props);
    }
  }

  protected setSlotProps(selection: any, x: number) {
    let data = {
      panelColors : {normal : '#16396f', hover : '#214783', pressed : '#2a518e'},
      radius : 10,
      borderWidth : 2,
      borderColor : '#000000',
      textColors : {normal : '#ffffff'},
      callback : () => {
        if (selection)
          Game.instance.matchThree.onPowerUpButton(Number(selection), x);
      },
      anchor : {x : 0, y : 0},
      pivot : {x : 0, y : 0},
      size : {x : 50, y : 50},
      position : {x : x, y : 10},
      parent : this.powerupsPanel
    };

    return data;
  }

  protected setSlotImageProps(url: string, parent: any) {
    let data = {
      url : url,
      anchor : {x : 0.5, y : 0.5},
      pivot : {x : 0.5, y : 0.5},
      position : {x : 0, y : 0},
      size : {x : 44, y : 44},
      stretch : true,
      parent : parent
    };

    return data;
  }

  private onEventUpdated(data: any) {
    if(data.action == 'connect' || data.action == 'disconnect' || data.action == 'presence')
      return;

    let dot = new UIPanel({
      size: {x: 10, y: 10},
      position: {x: 35, y: 0},
      radius: 5,
      color: 'red',
      parent : this.playPlaceButton
    });
  }

  public onWake() {
    this.menuPanel.visible = false;
    this.goalsPanel.visible = false;
    // this.goalsGrid.deleteAllChildren();
    this.gamePanel.fitParent.top = 70;
    this.powerupsPanel.visible = false;
    this.timeFreezeImage.visible = false;
    this.levelPanel.visible = true;
    this.readyGoText.visible = false;

    let qs = new URLSearchParams(window.location.search);
    if(qs.has('room')) {
      // Game.game.solitaire.clear();
      // Game.game.joinRoom(qs.get('room'));
    }
    else
      Game.instance.start();

    this.onEventUpdated = this.onEventUpdated.bind(this);
    Server.messages.addEventListener('chat-started', this.onEventUpdated);
    Server.messages.addEventListener('chat-updated', this.onEventUpdated);
    Server.user.addEventListener('friend-updated', this.onEventUpdated);
  }

  public pause() {
    Game.instance.matchThree.pause();
  }

  public resume() {
    Game.instance.matchThree.resume();
  }

  public update() {
    super.update();

    // this.playWithFriendsButton.visible = !Site.room.isActive();

    let matchThree = Game.instance.matchThree;
    if(!matchThree)
      return;
    if(matchThree.score == undefined)
      return;

    this.scoreText.text = `${numberWithCommas(matchThree.score)}`;

    if (matchThree.isTimedGame()) {
      this.timeLabel.text = 'TIME';
      this.timeText.text = `${getTimeString(matchThree.timeLeft)}`;

      if (matchThree.timeFreezeCountdown > 0) {
        this.timeFreezeImage.visible = true;
        let secondsLeft = `${Math.floor((matchThree.timeFreezeCountdown + 999) / 1000)}`;
        // this.timeFreezeText.text = secondsLeft;
        this.timeText.text = secondsLeft;
      }
      else {
        this.timeFreezeImage.visible = false;
      }
    }
    else {
      this.timeLabel.text = 'MOVES';
      this.timeText.text = `${numberWithCommas(matchThree.movesLeft)}`;
      this.timeFreezeImage.visible = false;
    }

    if (Game.instance.gameMode == GameMode.Adventure) {
      let goals = matchThree.getGoals();
      for(let i = 0; i < goals.length; i++) {
        let countText = this.goalsGrid.getChild(i).getChild(1) as UIText;
        countText.text = goals[i].amount.toString();
      }

      let goalsLocked = matchThree.getGoalsLocked();
      if(goalsLocked >= 0) {
        if (this.goalsGrid.childCount > goals.length) {
          let countText = this.goalsGrid.getChild(this.goalsGrid.childCount - 1).getChild(1) as UIText;
          countText.text = goalsLocked.toString();
        }
      }
    }

    if (Game.instance.gameMode == GameMode.Adventure) {
      this.levelText.text = Game.instance.levelSelected.toString();
      this.levelPanel.visible = true;
    }
    else
      this.levelPanel.visible = false;
  }

  public startGame() {
    if (Game.instance.gameMode == GameMode.Adventure) {
      this.goalsPanel.visible = true;
      this.gamePanel.fitParent.top = 120;
      this.powerupsPanel.visible = true;
      this.gamePanel.fitParent.bottom = 80;
      this.buildGoals();
      this.buildPowerups();
    }
    else {
      this.goalsPanel.visible = false;
      this.gamePanel.fitParent.top = 70;
      this.powerupsPanel.visible = true;
      this.gamePanel.fitParent.bottom = 80;
      this.buildPowerups();
      this.toastReadyGo();
    }
  }

  protected onMenu() {
    this.menuPanel.visible = !this.menuPanel.visible;

    if(this.menuPanel.visible) {
      this.toggleSoundOnIcon.visible = SoundManager.instance.sfxOn;
      this.toggleSoundOffIcon.visible = !SoundManager.instance.sfxOn;
    }
  }

  public onLeaderboardClick() {
    // if(Site.room.isActive())
    //   Game.instance.showRoom();
    // else {
    //   Game.instance.askQuestion('Quit the game and\nreturn to Play Place?', (response:string)=>{
    //     if(response == 'Yes')
    //       Game.instance.quit();
    //   });
    // }

    Game.instance.askQuestion('Quit the game and\nreturn to Play Place?', (response:string)=>{
      if(response == 'Yes')
        Game.instance.quit();
    });
  }

  // protected onPlayWithFriends() {
  //   Game.game.askQuestion('Start a new game with friends?', (response:string)=>{
  //     if(response == 'Yes') {
  //       Game.game.createRoom((success:boolean)=>{
  //         if(success)
  //           Game.game.finish();
  //       });
  //     }
  //   });
  // }

  protected onPause() {
    this.pause();

    Game.instance.pauseDialog.showModal((action:string)=>{
      if(action == 'restart') {
        Game.instance.askQuestion('Start a new game?', (response:string)=>{
          if(response == 'Yes') {
            Game.instance.finish();

            if (Game.instance.gameMode == GameMode.Arcade)
              Game.instance.arcadeMode();
            else
              Game.instance.mapScreen.show();
          } else
            this.resume();
        });
      }
      else if(action == 'quit') {
        Game.instance.askQuestion('Quit the game and\nreturn to Play Place?', (response:string)=>{
          if(response == 'Yes')
            Game.instance.quit();
          else
            this.resume();
        });
      } 
      else if(action == 'options') {
        Game.instance.gameOptionsDialog.showModal(()=>{
          this.onPause();
        });
      }
      else
        this.resume();
    });
  }

  protected onPPMenu() {
    this.pause();

    Game.instance.playPlaceMenu.showModal((action:string)=>{
      if (action) {
        Game.instance.askQuestion('Quit the game and\nreturn to Play Place?', (response:string)=>{
          if(response == 'Yes') {
            let menu = AppConfig.menu;

            if(action == menu[0].text)
              window.open(menu[0].to, '_self');
            else if(action == menu[1].text)
              window.open(menu[1].to, '_self');
            else if(action == menu[2].text)
              window.open(menu[2].to, '_self');
            else if(action == menu[3].text)
              window.open(menu[3].to, '_self');
            else if(action == menu[5].text)
              window.open(menu[5].to, '_self');
            else if(action == menu[6].text)
              window.open(menu[6].to, '_self');
          }
          else
            this.resume();
        });
      }
      else
        this.resume();
    });
  }

  public toastReadyGo() {
    return new Promise((resolve, reject) => {
      let y = this.readyGoText.position.y;

      Game.instance.matchThree.pause();

      let duration = 200;
      let delay = 800;
      let halfWidth = (UICanvas.instance.width/2);

      setTimeout(() => {
        this.readyGoText.text = 'Ready...';
        this.readyGoText.visible = true;
        this.readyGoText.slide(0 + halfWidth + this.readyGoText.width, y, 0, y, duration);
        
        setTimeout(() => {
          this.readyGoText.slide(0, y, 0 - halfWidth - this.readyGoText.width, y, duration, ()=>{
            this.readyGoText.text = 'Set...';
            this.readyGoText.slide(0 + halfWidth + this.readyGoText.width, y, 0, y, duration);
    
            setTimeout(() => {
              this.readyGoText.slide(0, y, 0 - halfWidth - this.readyGoText.width, y, duration, ()=>{
                this.readyGoText.text = 'GO!';
                this.readyGoText.slide(0 + halfWidth + this.readyGoText.width, y, 0, y, duration);
    
                setTimeout(() => {
                  this.readyGoText.slide(0, y, 0 - halfWidth - this.readyGoText.width, y, duration, ()=>{
                    this.readyGoText.visible = false;
                    Game.instance.matchThree.resume();
                    resolve(true);
                  });
                }, delay);
              });
            }, delay);
          });
        }, delay);
      }, 350);
    })
  }
}
